<template>
  <div class="card card-performance-objective">
    <div class="card-header">
      <div class="row no-gutters">
        <div class="col d-flex align-items-center">
          <h3
            class="mb-0"
          >{{ objective.description }}</h3>
        </div>
        <div class="col-auto d-flex align-items-center"></div>
      </div><!-- /.row -->
    </div>

    <ul class="list-data no-hover">
      <li class="data-heading">
        <div class="row">
          <div class="col-12 col-lg-7">
            <p>Key Milestones</p>
          </div>
          <div class="col-6 col-lg-2">
            <p>Start Date</p>
          </div>
          <div class="col-6 col-lg-2">
            <p>End Date</p>
          </div>
        </div><!-- /.row -->
      </li>

      <li v-for="milestone in milestones" :key="milestone.id">
        <div class="row">
          <div class="col-12 col-lg-7">
            <p class="sr-only">Key milestone</p>
            <div class="form-control-plaintext quill-html"><div v-html="milestone.description" /></div>
          </div>
          <div class="col-6 col-lg-2">
            <p class="sr-only">Key milestone start date</p>
            <p class="form-control-plaintext">{{ milestone.start_date | date('YYYY-MM-DD') }}</p>
          </div>
          <div class="col-6 col-lg-2">
            <p class="sr-only">Key milestone end date</p>
            <p class="form-control-plaintext">{{ milestone.end_date | date('YYYY-MM-DD') }}</p>
          </div>
        </div><!-- /.row -->
      </li>
    </ul>
  </div><!-- /.card -->
</template>

<script>
export default {
  props: {

    objective: {
      required: true,
      type: Object
    }
  },

  computed: {
    milestones () {
      return this.objective.milestones
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-performance-objective {
    .row.no-gutters {
      max-width: 100%;
      h3.mb-0 {
        max-width: 100%;
      }
    }
  }
</style>
